import { ConvexProviderWithAuth, ConvexReactClient } from 'convex/react';
import { type ReactNode, useState } from 'react';
import { useConvexAppAuth } from './useConvexAppAuth';

type AuthProvidersProps = {
  convexUrl: string;
  children: ReactNode;
};

/**
 * AWS Cognito and Convex authentication providers. The client lives in state so
 * a re-render never opens a second WebSocket.
 */
export const AuthProviders = ({ children, convexUrl }: AuthProvidersProps) => {
  const [client] = useState(
    () => new ConvexReactClient(convexUrl, { unsavedChangesWarning: false, verbose: false }),
  );
  return (
    <ConvexProviderWithAuth client={client} useAuth={useConvexAppAuth}>
      {children}
    </ConvexProviderWithAuth>
  );
};
